import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dreamy%20ethereal%20cherry%20blossom%20anime%20landscape%20with%20soft%20pink%20petals%20floating%20in%20the%20air%2C%20warm%20golden%20sunset%20light%2C%20traditional%20Japanese%20temple%20silhouette%20in%20the%20distance%2C%20artistic%20painterly%20style%2C%20atmospheric%20and%20cinematic%20composition%2C%20soft%20focus%20dreamy%20aesthetic%2C%20gentle%20gradient%20sky&width=1800&height=1000&seq=hero-bg-sakura&orientation=landscape"
        alt="樱花动漫 - 手机动漫门户"
        className="absolute inset-0 w-full h-full object-cover object-top z-0"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40 z-[1]"></div>

      <div className="relative z-[2] w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-12">
          <div className="w-full lg:w-3/5">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight">
              <span className="block">发现你的</span>
              <span className="block mt-2">下一部</span>
              <span className="block mt-2">
                心动<span className="text-primary-400">动漫</span>
              </span>
            </h1>
            <p className="mt-6 text-sm md:text-base text-background-200 max-w-md leading-relaxed">
              樱花动漫网专为手机动漫迷打造，提供海量高清动漫资源。随时随地，畅享二次元世界的无限精彩。
            </p>
          </div>

          <div className="w-full lg:w-2/5 flex flex-col items-start lg:items-end lg:justify-end lg:pt-32">
            <p className="text-sm text-background-200/80 max-w-xs leading-relaxed mb-6 lg:text-right">
              覆盖热血战斗、奇幻冒险、异世界转生、恋爱日常等全类型动漫，每日更新不停歇
            </p>
            <Link
              to="/category/hot-blooded"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full border-2 border-background-50 text-background-50 text-sm font-medium hover:bg-background-50 hover:text-foreground-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              探索番剧
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}